import AxiosInstance from "../../utils/axios";

type ShowcaseResponse = {
  id: string;
  order: number;
  url: string;
  createdAt: Date;
};

async function getAllShowcases(
  signal: AbortSignal
): Promise<ShowcaseResponse[]> {
  return (await AxiosInstance.get("/showcases", { signal })).data.data;
}

const ShowcaseAPI = {
  getAllShowcases,
};
export default ShowcaseAPI;
